import React from 'react';
import { ClinicInfoPanel } from '../../settings/clinicsettings/info/clinicInfoParts';
import ClinicSettingsEmpty from '../../settings/clinicsettings/subparts/ClinicSettingsEmpty';

const EmailTemplates = () => {
    return (
        <ClinicInfoPanel title="Email templates" icon="bi-envelope">
            <ClinicSettingsEmpty
                icon="bi-envelope-open"
                title="Email editing not available here"
                description="Email template editing is not available in the clinic portal yet. Contact EyeconX support if you need changes to an email template."
            />
        </ClinicInfoPanel>
    );
};

export default EmailTemplates;
